import axios from "axios";
import { refreshToken } from "./authService"; // Function to refresh the token
import { getFromStorage, saveToStorage } from "utils/storage";
const baseURL = process.env.REACT_APP_API_URL;
const apiClient = axios.create({
  baseURL: baseURL,
});

apiClient.interceptors.request.use(
  (config) => {
    const token =
      getFromStorage("user_token") || getFromStorage("user_data")?.access_token;
    // const token = getFromStorage("user_data")?.access_token;
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = "Bearer " + token;
            return axios(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise((resolve, reject) => {
        // ("rohan ya adnan");
        refreshToken()
          .then((newToken) => {
            saveToStorage("user_data", newToken);
            // saveToStorage("user_data", {
            //   ...getFromStorage("user_data"),
            //   access_token: newToken,
            // });
            apiClient.defaults.headers["Authorization"] =
              "Bearer " + newToken?.access_token;
            originalRequest.headers["Authorization"] =
              "Bearer " + newToken?.access_token;
            processQueue(null, newToken?.access_token);
            resolve(axios(originalRequest));
          })
          .catch((err) => {
            window.location.reload();
            window.location.href = "/login";
            sessionStorage.clear();
            processQueue(err, null);
            reject(err);
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  }
);

export default apiClient;
